(() => {
  if (customElements.get('wbc-lrr-choose-two')) return;
  class LrrPairBuy extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.form = this.querySelector('form');
      this.selects = [...this.querySelectorAll('[data-variant]')];
      this.productSelects = [...this.querySelectorAll('select[data-product]')];
      this.variantCatalog = this.productSelects.map(select => new Map(
        [...select.closest('[data-pick]').querySelector('[data-variant-template]').content.querySelectorAll('optgroup')]
          .map(group => [group.dataset.product, [...group.querySelectorAll('option')]])
      ));
      this.controls = [...this.selects, ...this.productSelects];
      this.submit = this.querySelector('[data-submit]');
      this.status = this.querySelector('[data-status]');
      this.sticky = this.querySelector('[data-sticky]');
      this.stickyButton = this.querySelector('[data-sticky-button]');
      this.inFlight = false;
      const signal = this.abort.signal;
      this.form.addEventListener('submit', event => this.addPair(event), { signal });
      this.productSelects.forEach((select, index) => {
        this.refreshPick(index);
        select.closest('[data-product-label]').hidden = false;
        select.addEventListener('change', () => { this.refreshPick(index); this.status.textContent = ''; this.update(); }, { signal });
      });
      this.selects.forEach(select => select.addEventListener('change', () => { this.status.textContent = ''; this.update(); }, { signal }));
      this.stickyButton?.addEventListener('click', () => {
        if (this.selects.every(select => select.value)) this.form.requestSubmit();
        else {
          this.querySelector('.lrr-pair').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
          this.selects.find(select => !select.value)?.focus({ preventScroll: true });
        }
      }, { signal });
      if (this.sticky) {
        document.body.classList.add('lrr-has-sticky');
        this.hero = document.querySelector('.lrr-story-hero');
        this.observer = new IntersectionObserver(() => this.updateSticky(), { threshold: 0 });
        [this.querySelector('.lrr-pair'), this.hero].filter(Boolean).forEach(node => this.observer.observe(node));
        window.addEventListener('scroll', () => this.updateSticky(), { passive: true, signal });
        document.addEventListener('variant:add', () => { this.sticky.hidden = true; }, { signal });
      }
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort(); this.abort = null; this.observer?.disconnect();
      if (this.sticky) document.body.classList.remove('lrr-has-sticky');
    }
    refreshPick(index) {
      const product = this.productSelects[index];
      const variant = this.selects[index];
      const previousSize = variant.selectedOptions[0]?.dataset.size || '';
      const options = this.variantCatalog[index].get(product.value) || [];
      const sameSize = options.find(option => !option.disabled && option.dataset.size === previousSize);
      const prompt = variant.querySelector('option[value=""]').cloneNode(true);
      variant.replaceChildren(prompt, ...options.map(option => option.cloneNode(true)));
      variant.value = sameSize?.value || '';
      variant.setCustomValidity('');
      const pick = product.closest('[data-pick]');
      const image = pick.querySelector('[data-pick-image]');
      image.removeAttribute('srcset');
      image.src = product.selectedOptions[0].dataset.image;
      image.alt = product.selectedOptions[0].dataset.label;
      pick.querySelector('[data-size-label]').textContent = `${product.selectedOptions[0].dataset.label} ${this.dataset.sizeLabel}`;
    }
    selectedVariant(index) {
      const product = this.productSelects[index].value;
      const select = this.selects[index];
      const option = select.selectedOptions[0];
      if (!option?.value || option.disabled || option.dataset.product !== product) return null;
      return (this.variantCatalog[index].get(product) || []).find(candidate => candidate.value === option.value && !candidate.disabled) || null;
    }
    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(cents / 100);
    }
    update() {
      const variants = this.selects.map((select, index) => this.selectedVariant(index));
      const ready = variants.every(Boolean);
      {
        const total = variants.reduce((sum, variant, index) => sum + Number(variant?.dataset.price || this.productSelects[index].selectedOptions[0].dataset.price), 0);
        const formatted = this.money(total);
        this.querySelectorAll('[data-pair-price]').forEach(node => { node.textContent = formatted; });
        const shipping = Number(this.dataset.threshold) > 0 && total >= Number(this.dataset.threshold) ? this.dataset.shipping : this.dataset.shippingFallback;
        this.querySelectorAll('[data-shipping-label]').forEach(node => { node.textContent = shipping; });
        const rows = [...this.querySelectorAll('[data-pick-summary]')];
        const duplicate = ready && variants[0].value === variants[1].value;
        rows.forEach((row, index) => {
          row.hidden = duplicate && index === 1;
          const product = this.productSelects[index].selectedOptions[0];
          const quantity = duplicate ? 2 : 1;
          const price = Number(variants[index]?.dataset.price || product.dataset.price) * quantity;
          row.textContent = `${quantity} × ${product.dataset.label} · ${variants[index]?.dataset.size || this.dataset.sizePrompt} · ${this.money(price)}`;
        });
      }
      if (this.stickyButton) this.stickyButton.textContent = ready ? this.dataset.add : this.dataset.choose;
    }
    updateSticky() {
      if (!this.sticky || !this.hero) return;
      const rect = this.submit.getBoundingClientRect();
      const purchaseVisible = rect.bottom > 0 && rect.top < innerHeight;
      const drawerOpen = document.querySelector('cart-drawer[open], quick-buy-drawer[open]');
      this.sticky.hidden = purchaseVisible || this.hero.getBoundingClientRect().bottom > 0 || !!drawerOpen;
    }
    async addPair(event) {
      event.preventDefault();
      if (this.inFlight) return;
      const variants = this.selects.map((select, index) => this.selectedVariant(index));
      const invalid = variants.findIndex(variant => !variant);
      if (invalid !== -1) {
        const mismatched = Boolean(this.selects[invalid].value);
        this.selects[invalid].value = '';
        this.update();
        if (mismatched) this.status.textContent = this.dataset.selectionError;
        this.selects[invalid].focus();
        this.form.reportValidity();
        return;
      }
      if (!this.form.reportValidity()) return;
      const items = [];
      variants.forEach(variant => {
        const existing = items.find(item => item.id === Number(variant.value));
        if (existing) existing.quantity += 1;
        else items.push({ id: Number(variant.value), quantity: 1 });
      });
      this.inFlight = true;
      this.submit.disabled = true;
      this.controls.forEach(select => { select.disabled = true; });
      if (this.stickyButton) this.stickyButton.disabled = true;
      this.submit.setAttribute('aria-busy', 'true');
      this.querySelector('[data-button-label]').textContent = this.dataset.adding;
      this.status.textContent = '';
      this.querySelector('[data-cart-link]').hidden = true;
      const route = window.Shopify?.routes?.root || '/';
      const sections = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
      let added = false;
      try {
        const response = await fetch(`${route}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items, sections: [...new Set(sections)].slice(0, 5), sections_url: variants[0].dataset.url || location.pathname })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : '');
        added = true;
        if (window.themeVariables?.settings?.cartType === 'page') { location.href = `${route}cart`; return; }
        const cartResponse = await fetch(`${route}cart.js`);
        if (!cartResponse.ok) throw new Error('');
        const cart = await cartResponse.json();
        cart.sections = result.sections;
        const missing = sections.some(id => !cart.sections?.[id]);
        if (missing) { location.href = `${route}cart`; return; }
        this.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: result.items, cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } }));
        this.status.textContent = this.dataset.success;
      } catch (error) {
        if (added) { location.href = `${route}cart`; return; }
        this.status.textContent = [error.message, this.dataset.error].filter(Boolean).join(' ');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } finally {
        this.querySelector('[data-cart-link]').hidden = false;
        this.inFlight = false;
        this.submit.disabled = false;
        this.controls.forEach(select => { select.disabled = false; });
        if (this.stickyButton) this.stickyButton.disabled = false;
        this.submit.removeAttribute('aria-busy');
        this.querySelector('[data-button-label]').textContent = this.dataset.add;
      }
    }
  }
  customElements.define('wbc-lrr-choose-two', LrrPairBuy);
})();
